module.exports = __webpack_public_path__ + "static/media/DSC_0140.d9f8b592.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0140.jpg
// module id = 690
// module chunks = 0